module.exports = __webpack_public_path__ + "img/logo (9).3149933a.png";